<template>
  <div>
    <el-dialog
      title="玩家详情"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="830px"
    >
      <el-descriptions style="width: 781px" border>
        <template slot="title">
          <span v-if="form.thirdPartyId.search('DISCARDED_') == -1"
            >账号信息</span
          >
          <span v-else
            >账号信息 <span style="color: red">（已冻结）</span></span
          >
        </template>
        <template slot="extra">
          <el-button
            v-if="form.thirdPartyId.search('DISCARDED_') == -1"
            @click="discardPlayerAccount(form.aid)"
            type="primary"
            size="small"
            icon="el-icon-delete"
          >
            冻结
          </el-button>
        </template>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-postcard"></i>
            AID
          </template>
          {{ form.aid }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-c-scale-to-original"></i>
            渠道
          </template>
          {{ form.channelName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-c-scale-to-original"></i>
            来源
          </template>
          {{ form.source }}
        </el-descriptions-item>        
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-c-scale-to-original"></i>
            第三方ID
          </template>
          {{ form.thirdPartyId }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-coin"></i>
            付费总额
          </template>
          {{ (form.totalPaidPriceCentsOfAccount / 100).toFixed(2) }}元&nbsp;
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-c-scale-to-original"></i>
            注册时间
          </template>
          {{ ms2ymdhm(Number(form.registerAt)) }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline" span="2"></i>
            最近登录的省市
          </template>
          {{
            form.district.province == form.district.city
              ? form.district.province
              : form.district.province + " " + form.district.city
          }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-lock"></i>
            在黑名单
          </template>
          <span v-if="!form.isAidBlackEntry" style=""
            >否&nbsp;
            <a
              v-if="!form.isAidBlackEntry"
              @click="openAddBlackEntryDialog('aid', form.aid)"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [拉入]
            </a>
          </span>
          <span v-if="form.isAidBlackEntry" style="color: red"
            >是&nbsp;
            <a
              v-if="form.isAidBlackEntry"
              @click="removeBlackEntry('aid')"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [解除]
            </a>
            <a
              v-if="form.isAidBlackEntry"
              @click="toBlackEntryPage('aid')"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [详情]
            </a>
          </span>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        :column="2"
        title="角色信息"
        style="width: 781px; margin-top: 20px"
        border
      >
        <template slot="extra">
          <el-dropdown trigger="click" @command="handleGameOperationCommand">
            <el-button type="primary" size="small" class="el-dropdown-link"
              >操作<i class="el-icon-arrow-down el-icon--right"></i
            ></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="$bizutil.hasAnyPrivilege(['createOrder'])"
                icon="el-icon-shopping-cart-2"
                command="compensationOrder"
                >创单</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-postcard"></i>
            UID
          </template>
          {{ form.uid }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-c-scale-to-original"></i>
            昵称
          </template>
          {{ form.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-s-grid"></i>
            区服
          </template>
          {{ form.zoneId }}区
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-c-scale-to-original"></i>
            创建时间
          </template>
          {{ ms2ymdhm(Number(form.createdAt)) }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-medal"></i>
            历史最高战力
          </template>
          {{ form.maxZhanli }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-medal"></i>
            历史最大关卡
          </template>
          {{ form.maxLevel }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-medal"></i>
            挖矿最大深度
          </template>
          {{ form.maxMiningDepth }}m
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-date"></i>
            最近活跃时间
          </template>
          {{ form.latestActiveAt != 0 ? ms2ymdhm(form.latestActiveAt) : "?" }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-date"></i>
            最近登录时间
          </template>
          {{ ms2ymdhm(form.loginAt) }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile"></i>
            最近登录版本
          </template>
          {{ form.loginGameVersion }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-lock"></i>
            在灰名单
          </template>
          <span v-if="!form.isInteractiveForbidden" style=""
            >否&nbsp;
            <a
              v-if="!form.isInteractiveForbidden"
              @click="openAddGreyEntryDialog"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [拉入]
            </a>
          </span>
          <span v-if="form.isInteractiveForbidden" style="color: red"
            >是&nbsp;
            <a
              v-if="form.isInteractiveForbidden"
              @click="removeGreyEntry"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [解除]
            </a>
            <a
              v-if="form.isInteractiveForbidden"
              @click="toGreyEntryPage"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [详情]
            </a>
          </span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-lock"></i>
            在黑名单
          </template>
          <span v-if="!form.isBlackEntry" style=""
            >否&nbsp;
            <a
              v-if="!form.isBlackEntry"
              @click="openAddBlackEntryDialog('uid', form.uid)"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [拉入]
            </a>
          </span>
          <span v-if="form.isBlackEntry" style="color: red"
            >是&nbsp;
            <a
              v-if="form.isBlackEntry"
              @click="removeBlackEntry('uid')"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [解除]
            </a>
            <a
              v-if="form.isBlackEntry"
              @click="toBlackEntryPage('uid')"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [详情]
            </a>
          </span>
        </el-descriptions-item>        
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-notebook-2"></i>
            付费总额
          </template>
          {{ (form.payHistory.totalPaidPriceCents / 100).toFixed(2) }}元&nbsp;
          <a
            v-if="form.payHistory.totalPaidPriceCents > 0"
            @click="openOrderInfoDialog"
            style="text-decoration: none; font-size: small"
            href="javascript:;"
          >
            [明细]
          </a>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-notebook-2"></i>
            消费总额
          </template>
          {{ (form.consumeHistory.totalPaidPriceCents / 100).toFixed(2) }}元&nbsp;
          <a
            v-if="form.consumeHistory.totalPaidPriceCents > 0"
            @click="openConsumeHistoriesDialog"
            style="text-decoration: none; font-size: small"
            href="javascript:;"
          >
            [明细]
          </a>
        </el-descriptions-item>        
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-notebook-2"></i>
            代币余额
          </template>
          {{ form.cashTokenBalance }}
        </el-descriptions-item>
      </el-descriptions>
      <div v-if="form.payHistory.totalPaidPriceCents > 0">
        <el-descriptions
          :column="1"
          title="角色付费信息"
          style="width: 781px; margin-top: 20px"
          border
        >
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-notebook-2"></i>
              总额
            </template>
            {{ (form.payHistory.totalPaidPriceCents / 100).toFixed(2) }}元&nbsp;
            <a
              v-if="form.payHistory.totalPaidPriceCents > 0"
              @click="openOrderInfoDialog"
              style="text-decoration: none; font-size: small"
              href="javascript:;"
            >
              [明细]
            </a>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-notebook-2"></i>
              首次
            </template>
            <span
              >时间：{{
                ms2datetime(Number(form.payHistory.firstTimePay.paidAt))
              }}</span
            >
            <br />
            <span
              >金额：{{ (form.payHistory.firstTimePay.paidPriceCents / 100).toFixed(2) }}元</span
            >
            <br />

            <span
              >支付项：{{ form.payHistory.firstTimePay.payProductName }}</span
            >
            <br />
            <span>支付项ID：{{ form.payHistory.firstTimePay.payPointId }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-notebook-2"></i>
              末次
            </template>
            <span
              >时间：{{
                ms2datetime(Number(form.payHistory.lastTimePay.paidAt))
              }}</span
            >
            <br />
            <span>金额：{{ (form.payHistory.lastTimePay.paidPriceCents / 100).toFixed(2) }}元</span>
            <br />
            <span
              >支付项：{{ form.payHistory.lastTimePay.payProductName }}</span
            >
            <br />
            <span>支付项ID：{{ form.payHistory.lastTimePay.payPointId }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="form.guildInfo != null">
        <el-descriptions
          :column="2"
          title="公会信息"
          style="width: 781px; margin-top: 20px"
          border
        >
          <template slot="extra">
            <el-dropdown trigger="click" @command="handleGuildOperationCommand">
              <el-button type="primary" size="small" class="el-dropdown-link"
                >操作<i class="el-icon-arrow-down el-icon--right"></i
              ></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-search" command="info"
                  >查看公会</el-dropdown-item
                >
                <el-dropdown-item icon="el-icon-delete" command="kick"
                  >踢出公会</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-notebook-2"></i>
              公会名称
            </template>
            {{ form.guildInfo.name }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-postcard"></i>
              公会ID
            </template>
            {{ form.guildInfo.gid }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-set-up"></i>
              公会职位
            </template>
            <el-tag size="small">{{ form.guildInfo.title }}</el-tag>
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-date"></i>
              加入时间
            </template>
            {{ ms2ymdhm(form.guildInfo.joinedAt) }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

    <!-- “添加/修改灰名单项”对话框 -->
    <EditGreyListEntryDialog
      v-if="shouldEditGreyListEntryDialogVisible"
      @close="onEditGreyListEntryDialogClosed()"
      :value="valueForEditGreyListEntryDialog"
    ></EditGreyListEntryDialog>

    <!-- “添加/修改黑名单项”对话框 -->
    <EditBlackListEntryDialog
      v-if="shouldEditBlackListEntryDialogVisible"
      @close="onEditBlackListEntryDialogClosed()"
      :value="valueForEditBlackListEntryDialog"
    ></EditBlackListEntryDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

import EditGreyListEntryDialog from "./EditGreyListEntryDialog";
import EditBlackListEntryDialog from "./EditBlackListEntryDialog";

export default {
  data() {
    return {
      shouldEditGreyListEntryDialogVisible: false, // “添加/修改灰名单项”对话框是否应该显示出来
      valueForEditGreyListEntryDialog: null, // 要传递给“添加/修改灰名单项”对话框的数据
      shouldEditBlackListEntryDialogVisible: false, // “添加/修改黑名单项”对话框是否应该显示出来
      valueForEditBlackListEntryDialog: null, // 要传递给“添加/修改黑名单项”对话框的数据
      visible: true,
      form: {},
    };
  },

  components: {
    EditGreyListEntryDialog,
    EditBlackListEntryDialog,
  },

  created() {
    this.form = this.value.info;
    this.queryPlayerDetails();
  },

  props: {
    value: Object,
  },

  methods: {
    /**
     * 查询玩家信息
     */
    async queryPlayerDetails() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/player/getPlayerList`,
          {
            skip: 0,
            limit: 10,
            condition: "uid",
            value: this.form.uid + "",
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      // 为了保证弹窗和列表数据一致，不直接替换form，改为修改form中的值。即防止修改form的指针地址
      this.form = resData.data.list[0];
    },

    /**
     * 处理公会操作指令
     */
    async handleGuildOperationCommand(command) {
      switch (command) {
        case "info": {
          window.open(
            "#/console/guild/guildList?gid=" + this.form.guildInfo.gid
          );
          break;
        }
        case "kick": {
          await this.kickOutFromGuild(this.form);
          break;
        }
      }
    },
    /**
     * 处理游戏操作指令
     */
    async handleGameOperationCommand(command) {
      switch (command) {
        case "compensationOrder": {
          // 打开补单对话框
          dialogutil.open("CompensationOrderDialog", {
            data: this.form,
          });
          break;
        }
        case "ordersInfo": {
          // 打开付费明细对话框
          dialogutil.open("OrdersInfoDialog", {
            data: this.form,
          });
          break;
        }
      }
    },

    /**
     * 强制踢出
     * @param {*} entry
     */
    async kickOutFromGuild(entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认将uid为“${entry.uid}”、昵称为“${entry.name}”的玩家踢出公会[${entry.guildInfo.name}]？`
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/guild/kickOutGuildMember`,
            {
              gid: entry.guildInfo.gid,
              uid: entry.uid,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "踢出成功",
          type: "success",
        });
        this.form.guildInfo = null;
      } catch (e) {}
    },

    /**
     * 获取玩家订单集合
     */
    async openOrderInfoDialog() {
      // 打开付费明细对话框
      dialogutil.open("OrdersInfoDialog", {
        data: this.form,
      });
    },

    /**
     * 打开消费历史详情界面
     */
     async openConsumeHistoriesDialog() {
      dialogutil.open("ConsumeHistoriesDialog", {
        data: this.form,
      });
    },

    async discardPlayerAccount(aid) {
      await this.$alert(
        `<p  align= "left">该操作将会永久冻结此账号（以及此账号下的所有角色），玩家重进游戏后系统将为其创建新的账号（和角色）。</p>
          <br>
          <p  align= "left">另外，该操作并不会自动将此账号拉入灰名单或黑名单，如果需要，请自行手动操作。</p>`,
        "提示",
        {
          center: true,
          type: "warning",
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          callback: async (action) => {
            if (action == "confirm") {
              try {
                // // 弹确认框
                // await this.$confirm(
                //   `该操作将会永久冻结此账号（以及此账号下的所有角色），玩家重进游戏后系统将为其创建新的账号（和角色）。
                //   <br><br>另外，该操作并不会自动将此账号拉入灰名单或黑名单，如果需要，请自行手动操作。`,
                //   { dangerouslyUseHTMLString: true }
                // );

                let resData = (
                  await axios.post(
                    `${util.getBackendApiBase()}/v1/admin/discardPlayerAccount`,
                    {
                      aid: Number(aid),
                    },
                    {
                      headers: {
                        token: bizutil.getLoginUserToken(),
                      },
                    }
                  )
                ).data;
                if (resData.code > 0) {
                  this.$message.error(resData.message);
                  return;
                }

                this.$message({
                  message: "冻结成功",
                  type: "success",
                });
                setTimeout(() => {
                  this.queryPlayerDetails();
                }, 1100);
              } catch (e) {}
            }
          },
        }
      );
    },

    // 打开新增灰名单弹窗
    openAddGreyEntryDialog() {
      this.shouldEditGreyListEntryDialogVisible = true;
      this.valueForEditGreyListEntryDialog = {
        isCreate: true,
        oldData: null,
        uid: this.form.uid,
      };
    },
    /**
     * “添加灰名单项”对话框关闭了
     */
    async onEditGreyListEntryDialogClosed() {
      this.shouldEditGreyListEntryDialogVisible = false;
      setTimeout(() => {
        this.queryPlayerDetails();
      }, 1000);
    },

    // 从灰名单中移除
    async removeGreyEntry() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认从灰名单中移除uid为“${this.form.uid}”、昵称为“${this.form.name}”的玩家？`
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteGreyList`,
            {
              uidList: [this.form.uid + ""],
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        setTimeout(() => {
          this.queryPlayerDetails();
        }, 1100);
      } catch (e) {}
    },
    // 跳转到灰名单详情界面
    toGreyEntryPage() {
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: { uid: this.form.uid, tab: "grey-list" },
        }).href,
        "_blank"
      );
    },
    // 打开新增黑名单弹窗
    openAddBlackEntryDialog(radio, id) {
      this.shouldEditBlackListEntryDialogVisible = true;
      this.valueForEditBlackListEntryDialog = {
        isCreate: false,
        oldData: null,
        id: id,
        radio: radio,
      };
    },
    /**
     * “添加/修改黑名单项”对话框关闭了
     */
    async onEditBlackListEntryDialogClosed() {
      this.shouldEditBlackListEntryDialogVisible = false;
      setTimeout(() => {
        this.queryPlayerDetails();
      }, 1100);
    },

    // 从黑名单中移除
    async removeBlackEntry(radio) {
      try {
        if (radio == "uid") {
          // 弹确认框
          await this.$confirm(
            `确认从黑名单中移除uid为“${this.form.uid}”、昵称为“${this.form.name}”的玩家？`
          );
        } else {
          await this.$confirm(
            `确认从黑名单中移除aid为“${this.form.aid}”的玩家？`
          );
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteBlackListEntryById`,
            {
              uid: radio == "uid" ? this.form.uid : 0,
              aid: radio == "aid" ? this.form.aid : 0,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        setTimeout(() => {
          this.queryPlayerDetails();
        }, 1100);
      } catch (e) {}
    },
    // 跳转到黑名单详情界面
    toBlackEntryPage(radio) {
      let query =
        radio == "uid" ? { uid: this.form.uid } : { aid: this.form.aid };
      query["tab"] = "black-list";
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
    ms2datetime(ts) {
      return util.ms2datetime(ts);
    },
    getTitleName(title) {
      let name = "";
      switch (title) {
        case 0: {
          name = "普通成员";
          break;
        }
        case 1: {
          name = "会长";
          break;
        }
        case 2: {
          name = "副会长";
          break;
        }
      }
      return name;
    },
    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

/deep/.el-descriptions .is-bordered .el-descriptions-item__cell {
  padding: 6px 5px;
}
</style>

